// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__OxoFK","label":"SetPasswdForm_label__1xzbc"};